import React from "react";
import { LoggedInUserNotFlatResponse } from "@/services/api/user/contracts";
import { toast } from "@/components";
import styles from "./styles.scss";
import {
  CICPA_TOAST_ID,
  COMPANY_NAME_AR_TOAST_ID,
  TOAST_DEFAULT_DURATION,
} from "@/constants";
import { NavLink } from "react-router-dom";
import { navigationConfig } from "@/routes";

const globalErrorToast = (msg: React.ReactNode, toastId: string) => {
  const show = toast.error(msg, {
    duration: TOAST_DEFAULT_DURATION * 1000,
    className: styles.toastContainerExtraError,
    style: {
      opacity: 1,
    },
  });

  setTimeout(() => {
    document.querySelector(styles.toastContainerExtraError)?.scrollIntoView();
  }, 200);

  window.sessionStorage.setItem(toastId, show);
};

const prepareMsg = (message: string) => {
  const contractorProfileRouteConfig = navigationConfig[3];

  return (
    <div>
      <div style={{ fontWeight: "bold" }}>{message}</div>
      <div>
        Please fill it in the{" "}
        <NavLink to={contractorProfileRouteConfig.path}>
          {contractorProfileRouteConfig.title}
        </NavLink>{" "}
        page
      </div>
    </div>
  );
};

export const isUserFirstVisit = (data: LoggedInUserNotFlatResponse["Data"]) => {
  const CicpaId = data?.Contractor?.ContractorCicpaId;
  const CompanyNameAr = data?.Contractor?.CompanyNameAr;

  if (!CicpaId) {
    const msg = prepareMsg("CICPA ID is not provided.");
    globalErrorToast(msg, CICPA_TOAST_ID);
  }

  if (!CompanyNameAr) {
    const msg = prepareMsg("Arabic Name is not provided.");
    globalErrorToast(msg, COMPANY_NAME_AR_TOAST_ID);
  }
};
